import React, { useState, useImperativeHandle, forwardRef } from "react";
import { Constants } from "../../constants/appConstants";
import { AccountDetail } from "../../models/accounts/accountDetail";
import { csosApiService } from "../../services/api/csosApiService";
import { dateService } from "../../services/dateService";
import "./AccountDetails.css";

interface AccountDetailsProps {
  onClose: () => void;
}

const filterInclusions = ["id", "customerNumber", "distributionCenter", "name"];

function accountSearch(items: AccountDetail[], searchStr: string): AccountDetail[] {
  const upper = searchStr.toUpperCase();
  if (!items) return [];
  return items.filter((item) => {
    const parsed = item as any;
    const arr: string[] = [];
    for (const x in parsed) {
      if (filterInclusions.indexOf(x) > -1) {
        arr.push(String(parsed[x]));
      }
    }
    return arr.join(" ").toUpperCase().indexOf(upper) !== -1;
  });
}


const AccountDetails = forwardRef<{ getAccountDetailData: () => void }, AccountDetailsProps>(
  ({ onClose }, ref) => {
    const [accountDetails, setAccountDetails] = useState<AccountDetail[]>([]);
    const [filterValue, setFilterValue] = useState("");

    useImperativeHandle(ref, () => ({
      getAccountDetailData: () => {
        csosApiService.getAccountsForUser().then((res) => {
          if (res.body) {
            setAccountDetails(res.body);
          }
        });
      },
    }));
    
    const callCSOSOrders = (account: string) => {
      csosApiService.getEncyrptedAccounts(account).then((res) => {
        console.log("encryptedAccounts::" + res.body);
        let params =
          "ShipTo=" + encodeURIComponent(String(res.body)) +
          "&BusinessUnit=" + Constants.ORDER_EXPRESS_BUSINESS +
          "&TimeZone=" + dateService.getTimeZoneAbbr();
        console.log("params::" + params);
        if (params != null) {
          params = encodeURIComponent(params);
        }
        const csosUrl = Constants.ACCOUNT_URL + params;
        console.log("csosUrl::" + csosUrl);
        window.open(csosUrl, "AXWAY_WINDOW");
      });
    };

    const handleClose = () => {
      setFilterValue("");
      setAccountDetails([]);
      onClose();
    };

    const filtered = accountSearch(accountDetails, filterValue);

    return (
      <div className="modal-dialog modal-lg">
        <div className="modal-content modal-layout">
          <div className="account-selection-header">
            <button type="button" className="close close-button" onClick={handleClose}>
              &times;
            </button>
            <h6 className="modal-title">{Constants.ACCOUNT_SELECTION}</h6>
          </div>
          <div className="modal-body">
            <div>
              <span>
                <input
                  type="text"
                  className="filter"
                  maxLength={50}
                  placeholder="Enter Filter Criteria"
                  value={filterValue}
                  onChange={(e) => setFilterValue(e.target.value)}
                  onClick={(e) => (e.target as HTMLInputElement).select()}
                />
                <a className="clear-filter" onClick={() => setFilterValue("")}>
                  {Constants.CLEAR_FILTER}
                </a>
              </span>
            </div>
            <div className="table-container account-table">
              <table className="table table-bordered">
                <thead className="account-table-header">
                  <tr>
                    <th>{Constants.DC_ACCOUNT}</th>
                    <th>{Constants.DC}</th>
                    <th>{Constants.ACCOUNT}</th>
                    <th className="account-name-header">{Constants.ACCOUNT_NAME}</th>
                  </tr>
                </thead>
                <tbody>
                  {filtered.map((account, idx) => (
                    <tr key={idx}>
                      <td className="dc-account">{account.id}</td>
                      <td className="dc">{account.distributionCenter}</td>
                      <td className="account-col">
                        <a
                          href="#"
                          onClick={(event) => {
                            event.preventDefault();
                            callCSOSOrders(account.id);
                          }}
                        >
                          {account.customerNumber}
                        </a>
                      </td>
                      <td className="account-name">{account.name}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="modal-footer">
            <span>
              <input
                type="button"
                value="Cancel"
                className="btn btn-secondary cancel close"
                onClick={handleClose}
              />
            </span>
          </div>
        </div>
      </div>
    );
  }
);

export default AccountDetails;
